/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import RouteListener from "components/routeListener";
import Routes from "./routes";
import ScrollToTop from "./components/scrollToTop";
import defaultState, { userReducer, UserContext } from "./utils/reducers/user";
import { useCustomReducer } from "./utils/customHooks";
import type { UserToken } from "./utils/types/user.type";
import "./app.scss";
import "@repo/ui/src/styles/globals.css";
import { setCurrentUser } from "./utils/actions/user";
import lookUpState, {
  LookUpContext,
  lookUpReducer,
} from "utils/reducers/lookup";
import LicenseExpiryToast from "components/warning-toast";
import IdleManager from "components/IdleManager";
import { UserAgreementProvider } from "views/verification/login-agreement";

export default function App() {
  const [loginData, setLoginData] = useState(null);
  const [user, userDispatch] = useCustomReducer(
    userReducer,
    defaultState,
    false,
  );

  const [lookUp, lookUpDispatch] = useCustomReducer(
    lookUpReducer,
    lookUpState,
    false,
  );

  useEffect(() => {
    if (window.self !== window.top) {
      window.addEventListener("message", (event) => {
        if (
          event.origin === process.env.REACT_APP_ADMIN &&
          event.data.type === "login"
        ) {
          if (event.data.auth) {
            setLoginData(JSON.parse(event.data.auth));
            if (userDispatch) setCurrentUser(userDispatch, event.data.auth);
            // Handle authenticated state
          } else {
            // eslint-disable-next-line no-console
            console.log("Not authenticated");
            setLoginData(null);
            // Handle unauthenticated state
          }
        }
      });
    } else {
      const sessionData = JSON.stringify({
        redirectUrl: window.location.pathname,
      });
      const encodedData = encodeURIComponent(sessionData);
      window.location.href = `${process.env.REACT_APP_ADMIN}/?sessionData=${encodedData}`;
    }
  }, [userDispatch]);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return loginData ? (
    <BrowserRouter>
      <ScrollToTop />
      <RouteListener />

      <UserContext.Provider
        value={{ ...(user as UserToken), dispatch: userDispatch }}
      >
        <LookUpContext.Provider
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          value={{ ...(lookUp as any), dispatch: lookUpDispatch }}
        >
          <UserAgreementProvider>
            <IdleManager />
            <LicenseExpiryToast />
            <Routes />
          </UserAgreementProvider>
        </LookUpContext.Provider>
      </UserContext.Provider>
    </BrowserRouter>
  ) : (
    <p>Unauthorized user</p>
  );
}
